export const OrganizationPath = '/organization';

export const OrganizationUrls = {
  page: `${OrganizationPath}`,
  detail: `${OrganizationPath}/:id`,
  getDetailPath: id => `${OrganizationPath}/${id}`,
};
